import { trigger, animate, transition, style, group, state, query, keyframes } from '@angular/animations';

export const fadeInAnimation =
    trigger('routeAnimations', [
      transition('* <=> fade', [
        query(':enter, :leave', [
          style({
            position: 'absolute',
            left: 0,
            width: '100%',
            opacity: 0,
            transform: 'scale(0) translateY(0)'
          }),
        ], {optional: true}),
        query(':enter', [
          animate('600ms ease',
            style({ opacity: 1, transform: 'scale(1) translateY(0)' })
          )
        ], {optional: true})
      ]),
    ]);

export const fadeIn = trigger('fadeIn', [
      transition(':enter', [
        style({
          opacity: '0',
        }),
        animate('500ms', style({ opacity: '1' }))
      ]),
      transition(':leave', [
        style({
          opacity: '1',
        }),
        animate('100ms', style({ opacity: '0' }))
      ])
    ]);


export const fastFadeIn = trigger('fastFadeIn', [
      transition(':enter', [
        style({
          opacity: '0',
        }),
        animate('350ms', style({ opacity: '1' }))
      ]),
      transition(':leave', [
        style({
          opacity: '1',
        }),
        animate('50ms', style({ opacity: '0' }))
      ])
    ]);

export const fastFadeSlideIn = trigger('fastFadeSlideIn', [
      transition(':enter', [
        style({
          opacity: '0',
          left: '-60vw'
        }),
        animate('350ms', style({ opacity: '1',
        left: '0' }))
      ]),
      transition(':leave', [
        style({
          opacity: '1',
        }),
        animate('50ms', style({ opacity: '0', left: '60vw' }))
      ])
    ]);

export const boxIn = trigger('boxIn', [
  transition(':enter', [
    animate('300ms', keyframes([
      style({ opacity: '0', transform: 'scale(0)', offset: 0 }),
      style({ opacity: '1', transform: 'scale(1.03)', offset: 0.9 }),
      style({ transform: 'scale(1)', offset: 1 }) ,
    ]))
  ]),
  transition(':leave', [
    style({
      opacity: '1',
      transform: 'scale(1)'
    }),
    animate('500ms', style({ opacity: '0', transform: 'scale(0)' }))
  ])
])

export const sizeIn = trigger('sizeIn', [
  transition(':enter', [
    animate('1000ms', keyframes([
      style({ opacity: '1', height: '0px', offset: 0 }),
      style({ opacity: '1', height: 'auto', offset: 1 }),
    ]))
  ]),
  transition(':leave', [
    animate('1000ms', keyframes([
      style({ opacity: '1', height: '*', offset: 0 }),
      style({ opacity: '1', height: '0px', offset: 1 }),
    ]))
  ])
])

export const badgeIn = trigger('badgeIn', [
  transition(':enter', [
    animate('200ms', keyframes([
      style({ 'font-size': '0px', offset: 0}),
      style({ 'font-size': '80px', offset: 0.5}),
      style({ 'font-size': '50px', offset: 1})
    ]))
  ]),
  transition(':leave', [
    style({ 'font-size': '50px' }),
    animate('200ms', style({ 'font-size': '0px' }))
  ])
])

export const slideInOutAnimation =
    // trigger name for attaching this animation to an element using the [@triggerName] syntax
    trigger('slideInOutAnimation', [

        // end state styles for route container (host)
        state('*', style({
            // the view covers the whole screen with a semi tranparent background
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
        })),

        // route 'enter' transition
        transition(':enter', [
          // styles at start of transition
          style({
            right: '-400%',
            backgroundColor: 'rgba(0, 0, 0, 0)'
          }),
          // animation and styles at end of transition
          animate('.5s ease-in-out', style({
            right: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }))
        ]),

        // route 'leave' transition
        transition(':leave', [
            animate('.5s ease-in-out', style({
                right: '-400%',
                backgroundColor: 'rgba(0, 0, 0, 0)'
            }))
        ])
    ]);
